import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useEffect, useRef } from 'react';
import { string, func, element, oneOfType, arrayOf, oneOf, bool, number } from 'prop-types';
import { forceVisible } from 'react-lazyload';
import { Container, Content, Overlay } from './sidebar.styles';
import Portal from '../../atoms/Portal';
import SidebarHeader from './SidebarHeader';
import Header from './sidebar-header';

const withPortal = children => /*#__PURE__*/React.createElement(Portal, {
  id: "portal-sidebar"
}, children);

const SidebarWrapper = _ref => {
  let {
    portal = false
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["portal"]);

  const Component = /*#__PURE__*/React.createElement(Sidebar, props);
  return portal ? withPortal(Component) : Component;
};

const Sidebar = _ref2 => {
  let {
    children,
    visible,
    direction,
    timeTransition,
    onClickOutside,
    headerTitle,
    fullScreen
  } = _ref2,
      props = _objectWithoutPropertiesLoose(_ref2, ["children", "visible", "direction", "timeTransition", "onClickOutside", "headerTitle", "fullScreen"]);

  const contentRef = useRef(null);
  useEffect(() => {
    var _contentRef$current;

    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = visible ? 'hidden' : originalStyle;
    if (contentRef != null && (_contentRef$current = contentRef.current) != null && _contentRef$current.scrollTop) contentRef.current.scrollTop = 0;
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, [visible]);
  useEffect(() => {
    forceVisible();
  }, [children]);
  return /*#__PURE__*/React.createElement(Container, {
    visible: visible,
    "data-testid": "sidebar"
  }, /*#__PURE__*/React.createElement(Content, _extends({
    forwardRef: contentRef,
    visible: visible,
    direction: direction,
    timeTransition: timeTransition,
    fullScreen: fullScreen,
    "data-testid": "content"
  }, props), headerTitle && /*#__PURE__*/React.createElement(SidebarHeader, {
    label: headerTitle,
    leftButton: {
      onClick: onClickOutside
    }
  }), children), /*#__PURE__*/React.createElement(Overlay, {
    "aria-hidden": "true",
    visible: visible,
    onClick: onClickOutside,
    "data-testid": "overlay"
  }));
};

process.env.NODE_ENV !== "production" ? Sidebar.propTypes = {
  children: oneOfType([string, element, arrayOf(element)]),
  direction: oneOf(['left', 'right']),
  timeTransition: number,
  visible: bool.isRequired,
  onClickOutside: func,
  headerTitle: string,
  fullScreen: bool,
  bg: string
} : void 0;
Sidebar.defaultProps = {
  direction: 'left',
  timeTransition: 0.3,
  headerTitle: null,
  fullScreen: false,
  visible: false,
  onClickOutside: () => {}
};
SidebarWrapper.Header = Header;
export default SidebarWrapper;